import { Grid, styled } from '@mui/material';
import { FC } from 'react';
import Key from './Key';

type KeyboardProps = {
  handleKeyClick: (value: string) => void;
};

const StyledKeyboardGrid = styled(Grid)(({ theme }) => ({
  height: '45%',
  textAlign: 'center',
  display: 'flex',
  alignContent: 'center',
  padding: 16,
  backgroundColor: theme.palette.background.default,
}));

const ORDERED_KEYS = [1, 2, 3, 0, 4, 5, 6, '.', 7, 8, 9, 'delete'];
export const Keyboard: FC<KeyboardProps> = ({ handleKeyClick }) => {
  return (
    <StyledKeyboardGrid item>
      <Grid container spacing={2}>
        {ORDERED_KEYS.map((value, idx) => (
          <Grid item xs={3} key={idx}>
            <Key value={value.toString()} onKeyClick={handleKeyClick} />
          </Grid>
        ))}
      </Grid>
    </StyledKeyboardGrid>
  );
};
